import {Injectable} from '@angular/core';
import {DcpApiService, DcpEntryGroup, IActiveCartService} from '@dcp/configurator';
import {ActiveCartService, getCartIdByUserId} from '@spartacus/cart/base/core';
import {Cart, MultiCartFacade, OrderEntry} from '@spartacus/cart/base/root';
import {AuthService, UserIdService, WindowRef} from '@spartacus/core';
import {Observable} from 'rxjs';
import {distinctUntilChanged, map, switchMap} from 'rxjs/operators';
import {AddressIdentity} from '../model/dcp-address-identity';
import {PaymentTypeCode} from '../model/order/dcp-order.model';

@Injectable({
  providedIn: 'root',
})
export class DcpActiveCartService extends ActiveCartService implements IActiveCartService {

  constructor(
    protected multiCartFacade: MultiCartFacade,
    protected userIdService: UserIdService,
    protected authService: AuthService,
    private dcpApiService: DcpApiService, windowRef: WindowRef
  ) {
    super(  multiCartFacade, userIdService, windowRef);
  }

  getCartIdByUserId(cart: Cart, userId: string): string {
    return getCartIdByUserId(cart, userId);
  }

  getEntryGroups(): Observable<DcpEntryGroup[]> {
    return this.activeCartId$.pipe(
      switchMap((cartId) => (this.multiCartFacade.getCart(cartId) as Observable<Cart>)),
      map(cart => cart?.entryGroups),
      distinctUntilChanged()
    );
  }

  updateContact(usage: string, userId: string, cartId: string, contactUid: string): Observable<Cart> {
    return this.dcpApiService.callOcc(
      'cartContact',
      {
        userId,
        cartId,
        contactUid,
        usage
      },
      {},
      'PATCH'
    );
  }

  updateAddress(addressUsage: string, userId: string, cartId: string, ownerUid: string, addressIdentity: AddressIdentity): Observable<Cart> {
    const {addressUid, externalAddressNumber, addressPk} = addressIdentity;
    return this.dcpApiService.callOcc(
      'cartAddress',
      {
        userId,
        cartId,
        ownerUid,
        addressUid,
        externalAddressNumber,
        addressPk,
        addressUsage
      },
      {},
      'PATCH'
    );
  }

  isActiveCartHasCardPayment(): Observable<boolean> {
    return this.getActiveCart().pipe(
      map(cart => this.isCardPayment(cart))
    );
  }

  isCardPayment(cart: Cart): boolean {
    return cart.paymentType.code === PaymentTypeCode.CARD;
  }

  getActiveCart(): Observable<Cart> {
    return this.getActive();
  }

  getOrderEntries(): Observable<OrderEntry[]> {
    return this.getEntries();
  }
}
